<template>
    <div
        id="cookies-bar"
        ref="cookiesBar"
    >
        <div id="cookies-bar-inner">
            <div id="cookies-bar-text">
                {{ text }}
                <span :data-dialog="slug">
                    {{ clickHere }}
                </span>
            </div>
            <span
                id="cookies-bar-button"
                @click="buttonClick"
            >
                {{ button }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        style: {
            type: Object,
            required: true,
        },

        text: {
            type: String,
            required: true,
        },

        slug: {
            type: String,
            required: true,
        },

        clickHere: {
            type: String,
            required: true,
        },

        button: {
            type: String,
            required: true,
        },
    },

    computed: {
        buttonTextColor() {
            if (this.style['bar-button-text']) {
                return this.style['bar-button-text'].value;
            } else {
                return this.style['button-text'].value;
            }
        },
    },

    methods: {
        buttonClick() {
            this.$refs.cookiesBar.classList.add('hide');
            localStorage.setItem('sb-cookies-bar', 'hide');
        },
    },

    mounted() {
        if (localStorage.getItem('sb-cookies-bar') === 'hide') {
            this.$refs.cookiesBar.classList.add('hide');
        }

        if (this.$refs.cookiesBar.querySelector('[data-dialog]')) {
            for (const dialog of this.$refs.cookiesBar.querySelectorAll('[data-dialog]')) {
                dialog.addEventListener('click', event => {
                    this.$store.commit('dialog/show', event.target.dataset.dialog);
                });
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@import 'zoe-organism-cookie-bar';

@layer organism {
    #cookies-bar {
        --background: v-bind('style.background.value');
        --text-color: v-bind('style.text.value');
        --button-background: v-bind('style["button-background"].value');
        --button-background-hover: v-bind('style["button-background-hover"].value');
        --button-text-color: v-bind('buttonTextColor');
    }
}
</style>
